import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './EngineeringTeam.scss'
import '../../../../../pages/styles.scss'
import tagSvg from '../../../../../../assets/images/WhoWeHelp/tag.svg'
import FooterSection from '../../../../../../components/reusable/HomePageSections/FooterSection/FooterSection.js';
import { teamMembers } from '../../../../../../components/reusable/Common/Constant.js';
import technologyMainImage from '../../../../../../assets/images/Community/Technology.png'

const EngineeringTeam = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, []);
    return (
        <div className='engineering-team-page-container container'>
            <div className='engineering-team-page-section section-1'>
                <div className='engineering-team-page-section-content text'>
                    <h1>Meet the Team: <span className="highlight">Engineering</span></h1>
                    <p>The engineering team at Virginia Rehab Physicians develops innovative technology and systems that empower our clinicians to provide exceptional care.</p>
                    <div className='button-section'>
                        <Link className='btn' to="/careers-and-culture">
                            <i className='bx bx-plus'></i>
                            Explore Career Opportunities
                        </Link>
                    </div>
                </div>
                <div className='engineering-team-page-section-content image'>
                    <div className='image-container'>
                        <img src={technologyMainImage} alt="" />
                    </div>
                </div>
            </div>
            <div className='engineering-team-page-section section-2'>
                <div className='engineering-team-page-section-content text'>
                    <div className='company-vision-title'>
                        <div className='tag' style={{
                            backgroundImage: `url(${tagSvg})`,
                        }}>
                            <span>Our Team</span>
                        </div>
                        <br />
                        <h1>Engineering</h1>
                    </div>
                    <div className='company-vision-para'>
                        <p>
                            The engineering team creates applications, data solutions, and internal tools designed to enhance the well-being of both patients and providers. Collaborating closely across all areas of the organization, we tackle complex technical challenges while making a meaningful difference in people’s lives.
                        </p>
                    </div>
                </div>
                <hr className="section-divider" />
                <div className='engineering-team-page-section-content text'>
                    <div className='company-vision-point bubble-point'>
                        <h2>Collaborative</h2>
                    </div>
                    <div className='company-vision-point bubble-point'>
                        <h2>Data Driven</h2>
                    </div>
                    <div className='company-vision-point bubble-point'>
                        <h2>Empathetic</h2>
                    </div>
                </div>
            </div>
            <div className='engineering-team-page-section section-3'>
                <div className='wrapper'>
                    <div className='engineering-team-page-section-content image'>
                        <div className='image-container image-1'>
                            <img src={teamMembers.farhan.image} alt="" />
                            <h1>{teamMembers.farhan.name}</h1>
                            <p>{teamMembers.farhan.designation}</p>
                            <div className='button-section'>
                                <Link
                                    className='btn-2'
                                    to="/team-member-details"
                                    state={{
                                        image: teamMembers.farhan.image,
                                        pageType: teamMembers.farhan.pageType,
                                        name: teamMembers.farhan.name,
                                        designation: teamMembers.farhan.designation,
                                        message: teamMembers.farhan.message,
                                    }}
                                >
                                    <i className='bx bx-right-arrow-alt' />
                                    Read More
                                </Link>
                            </div>
                        </div>
                        <div className='image-container image-2'>
                            <img src={teamMembers.yogi.image} alt="" />
                            <h1>{teamMembers.yogi.name}</h1>
                            <p>{teamMembers.yogi.designation}</p>
                            <div className='button-section'>
                                <Link
                                    className='btn-2'
                                    to="/team-member-details"
                                    state={{
                                        image: teamMembers.yogi.image,
                                        pageType: teamMembers.yogi.pageType,
                                        name: teamMembers.yogi.name,
                                        designation: teamMembers.yogi.designation,
                                        message: teamMembers.yogi.message,
                                    }}
                                >
                                    <i className='bx bx-right-arrow-alt' />
                                    Read More
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FooterSection />
        </div>
    )
}

export default EngineeringTeam
